import TitleHeader from "@standard/components/TitleHeader";
import JobAuthenForm from "./JobAuthenForm";
import JobAuthenTable from "./JobAuthenTable";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { USER_ROLE } from "data/constants";

const programType = "Transaction";
const templateProgramName = "Job Authen by ";
const templateURL = `transaction/jobauthen/`;

export default function ({ history }) {
  const { path } = useRouteMatch();
  let pathParams = path.split("/");
  let role = pathParams[pathParams.length - 1];
  const url = templateURL + role;
  const programName =
    templateProgramName + (role === USER_ROLE.MANAGER ? "Manager" : "Safety");

  return (
    <>
      <TitleHeader programName={programName} programType={programType} />
      <Switch>
        <Route exact path={path}>
          <JobAuthenTable url={url} />
        </Route>
        <Route path={`/transaction/jobauthen/:role/:action/:id?`}>
          <JobAuthenForm history={history} url={url} />
        </Route>
      </Switch>
    </>
  );
}
